import { useEffect, useRef, useState } from "react";
import { Box, Tabs, Tab, Paper, useTheme } from "@mui/material";
// import CIS_img from "../../assets/baseVersion/CIS_img.svg";
import CIS_img from "../../assets/baseVersion/CIS_img.svg";
import Spark_img from "../../assets/baseVersion/Details_Spark.svg";
import DISA_img from "../../assets/baseVersion/DISA.svg";
import Nist_img from "../../assets/baseVersion/Nist.svg";
import Hippa_img from "../../assets/baseVersion/hippa.svg";
import Pci_img from "../../assets/baseVersion/pcidss.svg";
import Mitre_img from "../../assets/baseVersion/mitre.svg";
import { useDispatch, useSelector } from "react-redux";
import { setButtonSelected, setCategorySelected } from "./TabSelection-slice";
import { RootState } from "../../store/store";
import axiosInstance from "../../axios/axios";
import SkeletonLoader from "../../modules/dashboard/shared/skeleton_loader";
import CIS_Dark from "../../assets/baseVersion/CIS_Dark.svg";
import Nist_Dark from "../../assets/baseVersion/Nist_Dark.svg";
import Mitre_Dark from "../../assets/baseVersion/Mitre_Dark.svg";
import Spark_Dark from "../../assets/baseVersion/Spark_Dark.svg";
import Hippa_Dark from "../../assets/baseVersion/Hippa_Dark.svg";
import customTemplateLogo from "../../assets/custom_template_logo.svg";
import { useParams } from "react-router-dom";

interface TabSelectionProps {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setTabsLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  module?: string
  id?: any
  parameterType?: string
}

const TabSelection: React.FC<TabSelectionProps> = ({ setLoading, setTabsLoading, module, id, parameterType }) => {
  const isTemplate =
    parameterType?.toLowerCase() === "template" ||
    parameterType?.toLowerCase() === "custom";
  const [selectedTab, setSelectedTab] = useState(0);
  const [tabsData, setTabsData] = useState<{ label: string; icon: string; category?: string }[]>(
    []
  );
  const [isLoading, setIsLoading] = useState(true);
  const [isReady, setIsReady] = useState(false);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const [isBenchVersions, setBenchVersions] = useState<any>()

  let resolvedModule = "";
  // console.log(location.pathname, "location.pathname");
  if (location.pathname === "/on-premises/security-posture") {
    resolvedModule = "on_premise";
  } else if (location.pathname === "/cloud/security-posture") {
    resolvedModule = "cloud";
  } else if (module === "on_premise" || module === "cloud") {
    resolvedModule = module;
  } else {
    resolvedModule = "";
  }

  const on_Prem_Tab_Selected = useSelector(
    (state: RootState) => state.OnPrem_DetailsSelectedTab.selectedTab
  );
  const Selected_Rowid = useSelector(
    (state: any) => state.OnPrem_DetailsSelectedTab.row_id
  );
  const selectedControlType = useSelector(
    (state: any) => state.OnPrem_DetailsSelectedTab.selectedControlType
  );

  const dispatch = useDispatch();
  // The clicked control's type (the row click stores it); read, not a dependency,
  // when the vendor list loads -- see the cloud case below.
  const selectedButton = useSelector(
    (state: { OnPrem_DetailsSelectedTab: { selectedButton: string } }) =>
      state.OnPrem_DetailsSelectedTab.selectedButton
  );
  const selectedButtonRef = useRef(selectedButton);
  selectedButtonRef.current = selectedButton;
  const selectedControlTypeRef = useRef(selectedControlType);
  selectedControlTypeRef.current = selectedControlType;
  // const [loading, setLoading] = useState(false); // Add loading state

  const iconMap: Record<string, string> = {
    CIS: isDarkMode ? CIS_Dark : CIS_img,
    SPARK: isDarkMode ? Spark_Dark : Spark_img,
    DISA: DISA_img,
    NIST: isDarkMode ? Nist_Dark : Nist_img,
    HIPPA: isDarkMode ? Hippa_Dark : Hippa_img,
    "PCI DSS": Pci_img,
    MITRE: isDarkMode ? Mitre_Dark : Mitre_img,
  };

  const { scan_uuid } = useParams<{ scan_uuid: string }>();

  useEffect(() => {
    if (isTemplate) {
      setTabsData([{ label: "Template", icon: customTemplateLogo }]);
      setIsReady(true);
      setIsLoading(false);
      setLoading(false);
      setTabsLoading?.(false);
      dispatch(setButtonSelected("template"));
      return;
    }

    const fetchData = async () => {
      if (!id) return;

      setLoading(true);
      setIsReady(false);
      try {
        const category_name = "Benchmark";
        // Only include scan_summary_id when it's defined (not available on dashboard)
        const scanParam = scan_uuid ? `&scan_summary_id=${scan_uuid}` : '';
        const response = await axiosInstance.get(
          `securityscan/vendor-device-versions/${id}?module=${module}&category_name=${category_name}${scanParam}`
        );
        const rawData = response?.data?.data;

        // Cloud: vendor-device-versions answers with a flat list of vendor names and no
        // control types, so there is nothing to parse (treating it as vendor -> model ->
        // versions threw, and no tab was ever built). Details must use the row's control
        // type. The compliance tab writes selectedButton, and reusing that made Details
        // request NIST after a NIST click.
        if (Array.isArray(rawData)) {
          const source = selectedControlTypeRef.current || selectedButtonRef.current;
          const names = String(source || "")
            .split(",")
            .map((item) => item.trim())
            .filter(Boolean)
            .map((item) => item.toUpperCase());
          setBenchVersions(rawData.length > 0 ? names : []);
          return;
        }

        // Use a Set to store unique control_display_name values
        const controlDisplayNamesSet = new Set<string>();

        Object.values(rawData || {}).forEach((deviceObj: any) => {
          Object.values(deviceObj).forEach((versions: any) => {
            versions.forEach((item: any) => {
              if (item.control_display_name) {
                controlDisplayNamesSet.add(item.control_display_name);
              }
            });
          });
        });

        setBenchVersions(Array.from(controlDisplayNamesSet)); // Convert Set to array

      } catch (error) {
        console.error("Error fetching CIS bench versions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, isTemplate, dispatch, setLoading, setTabsLoading, module, scan_uuid]);



  useEffect(() => {
    const fetchButtons = async () => {
      if (!Selected_Rowid || isTemplate) {
        setTabsLoading?.(false);
        return;
      }

      setIsLoading(true);
      setLoading(true);
      setTabsLoading?.(true);
      try {
        const response = await axiosInstance.get(
          `securityscan/compliance-list?parameter_name_id=${Selected_Rowid}&module=${resolvedModule}`
        );
        const categories = response?.data?.data?.categories || [];

        let dynamicTabs: { label: string; icon: string; category?: string }[] = [];

        if (on_Prem_Tab_Selected === 2) {
          // Details is the benchmark view for both on-prem and cloud.
          // controls-by-parameter must be called with category_name=Benchmark.
          if (isBenchVersions && isBenchVersions.length > 0) {
            dynamicTabs = isBenchVersions.map((benchmark: string) => {
              const label = benchmark;
              const icon = iconMap[label.toUpperCase()] || CIS_img;
              return { label, icon, category: "Benchmark" };
            });
          } else {
            if (resolvedModule === "cloud" && selectedControlType) {
              // For Cloud Details tab, use the row's control_type directly (e.g. only CIS or only NIST)
              const controlTypes = Array.isArray(selectedControlType)
                ? selectedControlType
                : String(selectedControlType)
                    .split(",")
                    .map((item: string) => item.trim())
                    .filter(Boolean);

              dynamicTabs = controlTypes.map((ctrl: string) => {
                const label = ctrl.toUpperCase();
                const icon = iconMap[label] || CIS_img;
                return { label, icon, category: "Benchmark" };
              });
            } else {
              const benchmark = categories.find(
                (cat: any) => cat.category_name === "Benchmark"
              );
              const framework = categories.find(
                (cat: any) => cat.category_name === "Framework"
              );
              const targetCat = benchmark?.controls ? benchmark : framework;
              if (targetCat?.controls && targetCat.controls.length > 0) {
                // If it's Framework, only take the first control (1 image) instead of both
                const controlsToMap = targetCat.category_name === "Framework"
                  ? [targetCat.controls[0]]
                  : targetCat.controls;

                dynamicTabs = controlsToMap.map((control: any) => {
                  const label = control.control_display_name;
                  const icon = iconMap[label.toUpperCase()] || CIS_img;
                  return { label, icon, category: "Benchmark" };
                });
              }
            }
          }
        } else if (on_Prem_Tab_Selected === 1) {
          // Framework, Benchmark (CIS lives here, not Framework), and MITRE (if present)
          const framework = categories.find(
            (cat: any) => cat.category_name === "Framework"
          );
          const benchmark = categories.find(
            (cat: any) => cat.category_name === "Benchmark"
          );
          const mitre = categories.find(
            (cat: any) => cat.category_name === "MITRE"
          );
          if (
            (framework?.controls && framework.controls.length > 0) ||
            (benchmark?.controls && benchmark.controls.length > 0)
          ) {
            [framework, benchmark].forEach((cat: any) => {
              if (cat?.controls) {
                dynamicTabs = dynamicTabs.concat(
                  cat.controls.map((control: any) => {
                    const label = control.control_display_name;
                    const icon = iconMap[label.toUpperCase()] || CIS_img;
                    return { label, icon, category: cat.category_name };
                  })
                );
              }
            });
          } else {
            categories.forEach((cat: any) => {
              if (cat.controls) {
                cat.controls.forEach((control: any) => {
                  const label = control.control_display_name;
                  if (label && !dynamicTabs.some((t) => t.label === label)) {
                    const icon = iconMap[label.toUpperCase()] || CIS_img;
                    dynamicTabs.push({ label, icon, category: cat.category_name });
                  }
                });
              }
            });
          }
          if (mitre?.controls) {
            dynamicTabs = dynamicTabs.concat(
              mitre.controls.map((control: any) => {
                const label = control.control_display_name;
                const icon = iconMap[label.toUpperCase()] || CIS_img;
                return { label, icon, category: mitre.category_name || "MITRE" };
              })
            );
          }
        } else {
          // Default case (e.g. dashboard where on_Prem_Tab_Selected is 0)
          // Collect controls from all categories
          const seenLabels = new Set<string>();
          categories.forEach((cat: any) => {
            if (cat.controls) {
              cat.controls.forEach((control: any) => {
                const label = control.control_display_name;
                if (label && !seenLabels.has(label)) {
                  seenLabels.add(label);
                  const icon = iconMap[label.toUpperCase()] || CIS_img;
                  dynamicTabs.push({ label, icon, category: cat.category_name });
                }
              });
            }
          });
        }

        // MITRE is added twice when the check has no framework (the fallback above lists every
        // category, then MITRE is appended again); keep the first tab of each name, as My Scans does
        const uniqueTabs = dynamicTabs.filter(
          (tab, index, self) =>
            index === self.findIndex((t) => t.label.toUpperCase() === tab.label.toUpperCase())
        );

        setTabsData(uniqueTabs);
        setIsReady(true);
      } catch (error) {
        console.error("Error fetching compliance list:", error);
        setTabsData([]);
      } finally {
        setIsLoading(false);
        setLoading(false);
        setTabsLoading?.(false);
      }
    };

    fetchButtons();
  }, [on_Prem_Tab_Selected, Selected_Rowid, isBenchVersions, selectedControlType, resolvedModule]);

  // Reset isReady when dependencies change
  useEffect(() => {
    if (isTemplate) {
      setTabsData([{ label: "Template", icon: customTemplateLogo, category: "Template" }]);
      setIsReady(true);
      setIsLoading(false);
      setTabsLoading?.(false);
      return;
    }
    setIsReady(false);
  }, [on_Prem_Tab_Selected, Selected_Rowid, isTemplate, setTabsLoading]);

  useEffect(() => {
    setSelectedTab(0);
    if (tabsData.length > 0) {
      dispatch(setButtonSelected(tabsData[0].label.toLowerCase()));
      dispatch(setCategorySelected(tabsData[0].category || "Benchmark"));
    }
  }, [on_Prem_Tab_Selected, tabsData]);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
    dispatch(setButtonSelected(tabsData[newValue].label.toLowerCase()));
    dispatch(setCategorySelected(tabsData[newValue].category || "Benchmark"));
  };

  const getButtonWidth = (count: number) => {
    const widthMap: Record<number, number> = {
      1: 130,
      2: 210,
      3: 310,
      4: 420,
    };
    return `${widthMap[count] || 520}px`;
  };

  const ButtonWidth = getButtonWidth(tabsData.length);

  if (!isReady || isLoading || tabsData.length === 0) {
    return (
      <Paper
        elevation={3}
        sx={{
          borderRadius: 2,
          overflow: "hidden",
          backgroundColor: isDarkMode ? "#191C24" : "#F1F1FF",
          p: 1,
          width: "200px",
          height: "60px",
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        <SkeletonLoader count={1} styles={{ height: 40, width: "100%" }} />
      </Paper>
    );
  }

  return (
    <Paper
      elevation={isTemplate ? 0 : 3}
      sx={{
        borderRadius: 2,
        overflow: "hidden",
        backgroundColor: isDarkMode ? "#191C24" : "#F1F1FF",
        p: 0.5,
        maxWidth: ButtonWidth,
        width: "100%",
        display: "flex",
        justifyContent: "flex-start",
        position: "sticky",
        ...(isTemplate && {
          boxShadow: isDarkMode
            ? "0 1px 4px rgba(0, 0, 0, 0.25)"
            : "0 1px 4px rgba(58, 42, 218, 0.12)",
        }),
      }}
    >
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="fullWidth"
        sx={{
          position: "relative",
          "& .MuiTabs-indicator": {
            height: "100%",
            backgroundColor: isDarkMode ? "#343842" : "white",
            // backgroundColor: "white",
            borderRadius: "8px",
            transition: "all 0.3s ease-in-out",
            zIndex: 1,
          },
        }}
      >
        {tabsData.map((tab, index) => (
          <Tab
            key={index}
            label={
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                gap={1}
                position="relative"
                zIndex={2}
              >
                <img
                  src={tab.icon}
                  alt={tab.label}
                  width={85}
                  height={25}
                  style={{ cursor: tabsData.length > 1 ? "pointer" : "default" }}
                />
              </Box>
            }
            sx={{
              textTransform: "none",
              color: selectedTab === index ? "black" : "#555",
              transition: "color 0.3s ease-in-out",
              minWidth: "100px",
              maxWidth: "150px",
            }}
          />
        ))}
      </Tabs>
    </Paper>
  );
};

export default TabSelection;